<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Solicitud de Acceso a la Información Pública - UNCP</title>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
    <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" rel="stylesheet">

</head>
<body class="fade-in">
    
    <div class="container p-0">
        <!-- Header -->
        <div class="header">
            <div class="header-content">
                <svg class="header-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
                <div>
                    <h1>Universidad Nacional del Centro del Perú</h1>
                    <p class="header-subtitle">SOLICITUD DE ACCESO A LA INFORMACIÓN PÚBLICA</p>
                </div>
            </div>
            <p class="header-note">
                (Texto Único Ordenado de la Ley de Transparencia y acceso a la Información Pública, 
                aprobado por Decreto Supremo Nº 043-2003-PCM)
            </p>
        </div>

        <div class="form-content">
            <form #solicitudForm="ngForm" (submit)="enviarFormulario()">

                <ng-container *ngIf="!generado">

                    <!-- Número de Registro -->
                    <!--
                    <div class="registro-section">
                        <div class="registro-group">
                            <label>Nº DE REGISTRO</label>
                            <input type="text" 
                                [(ngModel)]="solicitud.t2_numero_registro" 
                                name="numeroRegistro"
                                readonly
                                placeholder="Se genera automáticamente">
                        </div>
                    </div>
                    -->

                    <!-- Sección I -->
                    <div class="form-section">
                        <h2 class="section-title">I. FUNCIONARIO RESPONSABLE DE ENTREGAR LA INFORMACIÓN: <span class="text-danger">*</span></h2>
                        <input type="text" 
                            class="text-uppercase"
                            [(ngModel)]="solicitud.t2_funcionario_responsable"
                            name="funcionarioResponsable"
                            maxlength="75"
                            placeholder="Apellidos y nombres del funcionario"
                            required
                            #funcionarioResponsable="ngModel">
                        <div *ngIf="funcionarioResponsable.invalid && funcionarioResponsable.touched" class="text-danger small mt-1">
                            Este campo es obligatorio
                        </div>
                    </div>

                    <!-- Sección II -->
                    <div class="form-section">
                        <h2 class="section-title">II. DATOS DEL SOLICITANTE:</h2>
                        
                        <div style="margin-bottom: 1rem;">
                            <label>APELLIDOS Y NOMBRES / RAZÓN SOCIAL <span class="text-danger">*</span></label>
                            <input type="text" 
                                class="text-uppercase"
                                [(ngModel)]="solicitud.t2_apellidos_nombres"
                                name="apellidosNombres"
                                maxlength="100"
                                required
                                #apellidosNombres="ngModel">
                            <div *ngIf="apellidosNombres.invalid && apellidosNombres.touched" class="text-danger small mt-1">
                                Este campo es obligatorio
                            </div>
                        </div>

                        <div class="form-grid grid-2" style="margin-bottom: 1rem;">
                            <div>
                                <label>DOCUMENTO DE IDENTIDAD <span class="text-danger">*</span></label>
                                <select [(ngModel)]="solicitud.t2_tipo_documento" 
                                        name="tipoDocumento"
                                        required>
                                    <option value="DNI">DNI</option>
                                    <option value="L.M.">L.M.</option>
                                    <option value="C.E.">C.E.</option>
                                    <option value="RUC">RUC</option>
                                    <option value="OTRO">OTRO</option>
                                </select>
                            </div>
                            <div>
                                <label>NÚMERO <span class="text-danger">*</span></label>
                                <input type="text" 
                                    class="text-uppercase"
                                    [(ngModel)]="solicitud.t2_numero_documento"
                                    name="numeroDocumento"
                                    required
                                    #numeroDocumento="ngModel"
                                    maxlength="15">
                                <div *ngIf="numeroDocumento.invalid && numeroDocumento.touched" class="text-danger small mt-1">
                                    Este campo es obligatorio
                                </div>
                            </div>
                        </div>

                        <div class="form-grid grid-2" style="margin-bottom: 1rem;">
                            <div>
                                <label>CORREO <span class="text-danger">*</span></label>
                                <input type="text" 
                                    class="text-uppercase"
                                    [(ngModel)]="solicitud.t2_correo_electronico"
                                    name="correoElectronico"
                                    placeholder="CORREO ELECTRÓNICO"
                                    required
                                    #correoElectronico="ngModel"
                                    maxlength="100">
                                <div *ngIf="correoElectronico.invalid && correoElectronico.touched" class="text-danger small mt-1">
                                    Este campo es obligatorio
                                </div>
                            </div>
                            <div>
                                <label>TELÉFONO <span class="text-danger">*</span></label>
                                <input type="tel" 
                                    class="text-uppercase"
                                    [(ngModel)]="solicitud.t2_telefono"
                                    name="telefono"
                                    placeholder="NRO DE TELÉFONO"
                                    required
                                    #telefono="ngModel"
                                    maxlength="15">
                                <div *ngIf="telefono.invalid && telefono.touched" class="text-danger small mt-1">
                                    Este campo es obligatorio
                                </div>
                            </div>
                        </div>

                        <div style="margin-bottom: 1rem;">
                            <label>DOMICILIO <span class="text-danger">*</span></label>
                            <div class="form-grid grid-3">
                                <div>
                                    <input type="text" 
                                        class="text-uppercase"
                                        [(ngModel)]="solicitud.t2_direccion"
                                        name="direccion"
                                        maxlength="45"
                                        placeholder="AV / CALLE / JR. / PSJ. *"
                                        required
                                        #direccion="ngModel">
                                    <div *ngIf="direccion.invalid && direccion.touched" class="text-danger small mt-1">
                                        Este campo es obligatorio
                                    </div>
                                </div>
                                <div>
                                    <input type="text" 
                                        class="text-uppercase"
                                        [(ngModel)]="solicitud.t2_numero_direccion"
                                        name="numeroDireccion"
                                        maxlength="10"
                                        placeholder="Nº / DPTO / INT. *"
                                        required
                                        #numeroDireccion="ngModel">
                                        <div *ngIf="numeroDireccion.invalid && numeroDireccion.touched" class="text-danger small mt-1">
                                            Este campo es obligatorio
                                        </div>
                                </div>
                                <input type="text" 
                                    class="text-uppercase"
                                    [(ngModel)]="solicitud.t2_urbanizacion"
                                    name="urbanizacion"
                                    maxlength="45"
                                    placeholder="URBANIZACIÓN">
                            </div>
                        </div>

                        <div class="form-grid grid-3" style="margin-bottom: 1rem;">
                            <div>
                                <input type="text" 
                                    class="text-uppercase"
                                    [(ngModel)]="solicitud.t2_distrito"
                                    name="distrito"
                                    maxlength="40"
                                    placeholder="DISTRITO *"
                                    required
                                    #distrito="ngModel">
                                    <div *ngIf="distrito.invalid && distrito.touched" class="text-danger small mt-1">
                                        Este campo es obligatorio
                                    </div>
                            </div>
                            <div>
                                <input type="text" 
                                    class="text-uppercase"
                                    [(ngModel)]="solicitud.t2_provincia"
                                    name="provincia"
                                    maxlength="30"
                                    placeholder="PROVINCIA *"
                                    required
                                    #provincia="ngModel">
                                    <div *ngIf="provincia.invalid && provincia.touched" class="text-danger small mt-1">
                                        Este campo es obligatorio
                                    </div>
                            </div>
                            <div>
                                <input type="text" 
                                    class="text-uppercase"
                                    [(ngModel)]="solicitud.t2_departamento"
                                    name="departamento"
                                    maxlength="35"
                                    placeholder="DEPARTAMENTO *"
                                    required
                                    #departamento="ngModel">
                                    <div *ngIf="departamento.invalid && departamento.touched" class="text-danger small mt-1">
                                        Este campo es obligatorio
                                    </div>
                                </div>
                            </div>
                        </div>

                    <!-- Sección III -->
                    <div class="form-section">
                        <h2 class="section-title">III. INFORMACIÓN SOLICITADA <span class="text-danger">*</span></h2>
                        <textarea rows="4" 
                                [(ngModel)]="solicitud.t2_informacion_solicitada"
                                name="informacionSolicitada"
                                maxlength="400"
                                required
                                #informacionSolicitada="ngModel"
                                placeholder="Describa la información que solicita..."></textarea>
                        <div *ngIf="informacionSolicitada.invalid && informacionSolicitada.touched" class="text-danger small mt-1">
                            Este campo es obligatorio
                        </div>
                    </div>

                    <!-- Sección IV -->
                    <div class="form-section">
                        <h2 class="section-title">IV. DEPENDENCIA DE LA CUAL SE REQUIERE LA INFORMACIÓN:</h2>
                        <input type="text" 
                            class="text-uppercase"
                            [(ngModel)]="solicitud.t2_dependencia"
                            name="dependencia"
                            maxlength="100"
                            placeholder="Nombre de la dependencia">
                    </div>

                    <!-- Sección V -->
                    <div class="form-section">
                        <h2 class="section-title">V. FORMA DE ENTREGA DE LA INFORMACIÓN (MARCAR CON UN "X") <span class="text-danger">*</span></h2>
                        <div class="form-grid grid-3 px-2">
                            <label class="checkbox-group">
                                <input type="checkbox" 
                                    [(ngModel)]="solicitud.t2_entrega_copia_simple"
                                    name="entregaCopiaSimple">
                                <span>Copia simple</span>
                            </label>
                            <label class="checkbox-group">
                                <input type="checkbox" 
                                    [(ngModel)]="solicitud.t2_entrega_cd"
                                    name="entregaCd">
                                <span>CD</span>
                            </label>
                            <label class="checkbox-group">
                                <input type="checkbox" 
                                    [(ngModel)]="solicitud.t2_entrega_correo_electronico"
                                    name="entregaCorreo">
                                <span>Correo electrónico</span>
                            </label>
                            <label class="checkbox-group">
                                <input type="checkbox" 
                                    [(ngModel)]="solicitud.t2_entrega_diskette"
                                    name="entregaDiskette">
                                <span>Aplicaciones móviles de mensajería instantánea</span>
                            </label>
                            <label class="checkbox-group">
                                <input type="checkbox" 
                                    [(ngModel)]="solicitud.t2_entrega_otro"
                                    name="entregaOtro"
                                    (change)="onOtroChange()">
                                <span>Otro</span>
                            </label>
                        </div>
                        
                        <!-- Campo para especificar "Otro" -->
                        <div *ngIf="solicitud.t2_entrega_otro" class="mt-2">
                            <input type="text" 
                                [(ngModel)]="solicitud.t2_entrega_otro_especificar"
                                name="entregaOtroEspecificar"
                                maxlength="75"
                                placeholder="Especifique la forma de entrega..."
                                class="form-control">
                        </div>
                    </div>

                    <!-- Observaciones -->
                    <div class="form-section">
                        <label>OBSERVACIONES:</label>
                        <textarea rows="3" 
                                [(ngModel)]="solicitud.t2_observaciones"
                                name="observaciones"
                                maxlength="300"
                                placeholder="Observaciones adicionales..."></textarea>
                    </div>

                    <!-- Firma y fecha -->
                    <!--
                    <div class="form-grid grid-2" style="margin-bottom: 1.5rem;">
                        <div>
                            <label>APELLIDOS Y NOMBRES</label>
                            <div class="signature-box">
                                <span class="signature-text">{{ solicitud.t2_apellidos_nombres }}</span>
                            </div>
                        </div>
                        <div>
                            <label>FECHA Y HORA DE RECEPCIÓN</label>
                            <div class="signature-box">
                                <span class="signature-text">{{ solicitud.t2_fecha_creacion | date:'dd/MM/yyyy HH:mm' }}</span>
                            </div>
                        </div>
                    </div>

                    <div style="margin-bottom: 1.5rem;">
                        <label>FIRMA</label>
                        <div class="signature-box signature-box-large">
                            <span class="signature-placeholder">Firma del solicitante</span>
                        </div>
                    </div>
                    -->

                </ng-container>

                <!-- Mensajes de estado -->
                <div *ngIf="mensaje" class="alert" [ngClass]="{'alert-success': submitSuccess, 'alert-danger': !submitSuccess}" role="alert">
                    <i class="fas fs-lg me-2" [ngClass]="{'fa-check-circle': submitSuccess, 'fa-exclamation-triangle': !submitSuccess}"></i>
                    <span class="fs-5 fw-bold" [innerHTML]="submitMessage"></span>

                    <div class="mt-2 p-2">
                        <b>Nota*:</b> 
                        <p >
                            Este documento no tiene validez si no se presenta por Mesa de Partes Virtual de la Universidad Nacional del Centro del Perú.
                        </p>
                        <div class="mb-0 p-3">
                            <li><strong>Paso 1:</strong> Una vez generado el cargo, descargue el documento en formato PDF haciendo clic en el botón "Descargar PDF".</li>
                            <li><strong>Paso 2:</strong> Ingrese al sistema de mesa de partes virtual de la UNCP para completar el proceso de envío de su solicitud de información pública.</li>
                        </div>
                    </div>
                </div>

                <!-- Botones -->
                <div class="button-group">
                    <button type="button" 
                            class="btn btn-secondary" 
                            (click)="resetearFormulario()"
                            [disabled]="isSubmitting">
                        <i class="fas fa-undo"></i>
                        {{ generado ? 'Generar otro cargo' : 'Limpiar Formulario' }}
                    </button>
                    <button type="button" *ngIf="generado"
                            class="btn btn-danger" 
                            (click)="descargarFormulario()">
                        <i class="fas fa-download"></i>
                        Descargar PDF
                    </button>
                    <button type="submit" *ngIf="!generado"
                            class="btn btn-primary"
                            [disabled]="isSubmitting || solicitudForm.invalid">
                        <i class="fas fa-file-alt" *ngIf="!isSubmitting"></i>
                        <i class="fas fa-spinner fa-spin" *ngIf="isSubmitting"></i>
                        {{ isSubmitting ? 'Generando...' : 'Generar Cargo' }}
                    </button>
                    <a type="button" *ngIf="generado"
                            href="https://erpcampus.uncp.edu.pe"
                            class="btn btn-success"
                            target="_blank">
                        <i class="fas fa-link"></i>
                        Ir a Mesa de Partes Virtual
                    </a>
                </div>

            </form>
        </div>
    </div>

</body>
</html>
